import { render, staticRenderFns } from "./BpmAutoDesformApplyMore.vue?vue&type=template&id=82d7d7fc&scoped=true&"
import script from "./BpmAutoDesformApplyMore.vue?vue&type=script&lang=js&"
export * from "./BpmAutoDesformApplyMore.vue?vue&type=script&lang=js&"
import style0 from "./BpmAutoDesformApplyMore.vue?vue&type=style&index=0&id=82d7d7fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d7d7fc",
  null
  
)

export default component.exports